var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.meta.keepAlive)?_c('el-container',[_c('Sidebar'),_c('el-main',[_c('Navbar'),_c('router-view')],1)],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }